// Set webpack public path. Use environment variable set in EXT:project/Configuration/TypoScript/Setup/page.typoscript
__webpack_public_path__ = window.EfConfig.javaScriptDirectoryPath || '/js/';

import $ from 'jquery';

/*
 * Initialize UI
 */
import './js/Ui.mjs';

const $collectionCardGrid = $('.ef-collection-card-grid');
if ($collectionCardGrid.length) {
  import(/* webpackChunkName: "CollectionCardGrid" */ './component/collection-card-grid/CollectionCardGrid.mjs');
}

const $teaserFullscreen = $('.ef-teaser-fullscreen');
if ($teaserFullscreen.length) {
  import(/* webpackChunkName: "TeaserFullscreen" */ './component/teaser-fullscreen/TeaserFullscreen.mjs');
}

const $sliders = $('.swiper-container');
if ($sliders.length) {
  import(/* webpackChunkName: "Sliders" */ './js/modules/Sliders.mjs');
}

const $collectionSocialMedia = $('.ef-collection-social-media');
if ($collectionSocialMedia.length) {
  import(/* webpackChunkName: "CollectionSocialMedia" */ './component/collection-social-media/CollectionSocialMedia.mjs');
}

const $mapInteractive = $('#ef-map-interactive');
if ($mapInteractive.length) {
  import(/* webpackChunkName: "MapInteractive" */ './component/map-interactive/MapInteractive.mjs');
}

const $newsList = $('.ef-news-list');
if ($newsList.length) {
  import(/* webpackChunkName: "NewsList" */ './component/news-list/NewsList.mjs');
}

const $jobPostingsList = $('.ef-job-postings-list');
if ($jobPostingsList.length) {
  import(/* webpackChunkName: "JobPostingsList" */ './component/job-postings-list/JobPostingsList.mjs');
}

const $jobPostingsDetail = $('.ef-job-postings-detail');
if ($jobPostingsDetail.length) {
  import(/* webpackChunkName: "JobPostingsDetail" */ './component/job-postings-detail/JobPostingsDetail.mjs');
}

const $collectionTeaserEditorialHistory = $('#collection-teaser-editorial-history-container');
if ($collectionTeaserEditorialHistory.length) {
  import(/* webpackChunkName: "CollectionTeaserEditorialHistory" */ './component/collection-teaser-editorial-history/CollectionTeaserEditorialHistory.mjs');
}

(async () => {
  const $jobApplicationForm = $('#form-jobApplication');
  if ($jobApplicationForm.length) {
    const {JobApplicationForm} = await import('./js/forms/JobApplicationForm.mjs');
    new JobApplicationForm({
      $form: $jobApplicationForm,
    });
  }

  const $cammioApplication = $('#form-cammioApplication');
  if ($cammioApplication.length) {
    const {CammioApplicationForm} = await import('./js/forms/CammioApplicationForm.mjs');
    new CammioApplicationForm({
      $form: $cammioApplication,
    });
  }

  const $formContact = $('#form-formContact');
  if ($formContact.length) {
    const {FormContact} = await import('./js/forms/FormContact.mjs');
    new FormContact({
      $form: $formContact,
    });
  }
})();

import(/* webpackChunkName: "Tracking" */ './js/modules/Tracking.mjs');
